import { combineReducers } from 'redux';
import authReducer from '../store/auth/login/store/_reducer';
import adminCollegeReducer from '../store/admin/college-management/store/_reducer';
import adminSMEReducer from '../store/admin/sme-management/_reducer';
import adminDashboardReducer from '../store/admin/dashboard/store/_reducer';
import adminSmeApprovalReducer from '../store/admin/sme-approval/store/_reducer';
import adminCertificatesReducer from '../store/admin/certificates/store/_reducer';
import adminAnalyticsReducer from '../store/admin/analytics/store/_reducer';
import studentDashboardReducer from '../store/student/dashboard/store/_reducer';
import studentCoursesReducer from '../store/student/courses/store/_reducer';
import studentQuizzesReducer from '../store/student/quizzes/store/_reducer';
import studentAssessmentsReducer from '../store/student/assesments/store/_reducer';
import examReducer from '../store/student/exam/store/_reducer';
import studentResultsReducer from '../store/student/results/store/_reducer';
import smeDashboardReducer from '../store/sme/dashboard/store/_reducer';
import smeContentReducer from '../store/sme/content-upload/store/_reducer';
import smeQuizCreationReducer from '../store/sme/quiz-creation/store/_reducer';
import smeStudentAnalyticsReducer from '../store/sme/student-analytics/store/_reducer';
import smeNotificationsReducer from '../store/sme/notifications/store/_reducer';
import collegeDashboardReducer from '../store/college/dashboard/store/_reducer';
import collegeStudentReducer from '../store/college/student-management/store/_reducer';
import collegeProgressTrackingReducer from '../store/college/progress-tracking/store/_reducer';
import collegeCertificatePublishingReducer from '../store/college/certificate-publishing/store/_reducer';
import adminStudentReducer from './admin/student-management/store/_reducer';
import adminCourseReducer from './admin/course-management/store/_reducer';
import courseContentReducer from './admin/course-content-management/store/_reducer';
import studentProfileReducer from './student/profile/store/_reducer';
import adminConfigReducer from './admin/admin-config/store/reducer';
import courseReducer from './college/courses-info/store/reducer';
import contentApprovalReducer from './admin/content-approval/store/_reducer';
// import student from '../utils/API/BackendHelper/college/student';
import adminExamReducer from '../store/admin/exam/store/_reducer';
import studentNotificationsReducer from './student/notifications/store/_reducer';
import questionBankReducer from './admin/question-bank/store/_reducer';
import chatbotReducer from './chatbot/_reducer';
import chatbotSettingsReducer from './admin/chatbot-settings/_reducer';
import studentCertificatesReducer from './admin/student-certificates/_reducer';
import customCertificatesReducer from './admin/custom-certificates/store/_reducer';
import studentBulkUploadReducer from './admin/student-bulk-upload/store/_reducer';
import adminProgressTrackingReducer from './admin/progress-tracking/store/_reducer';
const rootReducer = combineReducers({
  auth: authReducer,
  adminCollege: adminCollegeReducer,
  adminSme: adminSMEReducer,
  adminDashboard: adminDashboardReducer,
  adminSmeApproval: adminSmeApprovalReducer,
  adminCertificates: adminCertificatesReducer,
  adminAnalytics: adminAnalyticsReducer,
  adminStudent: adminStudentReducer,
  adminCourse: adminCourseReducer,
  studentDashboard: studentDashboardReducer,
  studentCourses: studentCoursesReducer,
  studentQuizzes: studentQuizzesReducer,
  studentAssessments: studentAssessmentsReducer,
  studentExam: examReducer,
  adminExam: adminExamReducer,
  studentResults: studentResultsReducer,
  smeDashboard: smeDashboardReducer,
  smeContent: smeContentReducer,
  smeQuizCreation: smeQuizCreationReducer,
  smeStudentAnalytics: smeStudentAnalyticsReducer,
  smeNotifications: smeNotificationsReducer,
  collegeDashboard: collegeDashboardReducer,
  collegeStudent: collegeStudentReducer,
  collegeProgressTracking: collegeProgressTrackingReducer,
  collegeCertificatePublishing: collegeCertificatePublishingReducer,
  adminConfig: adminConfigReducer, // Added admin config reducer
  courseContent: courseContentReducer, // Added course content management reducer
  studentProfile: studentProfileReducer, // Added student profile reducer
  collegeCourse: courseReducer, // Added college courses info reducer
  contentApproval: contentApprovalReducer, // Added content approval reducer
  studentNotifications: studentNotificationsReducer, // Added student notifications reducer
  questionBank: questionBankReducer, // Added question bank reducer
  chatbot: chatbotReducer,
  adminChatbotSettings: chatbotSettingsReducer,
  studentCertificates: studentCertificatesReducer,
  customCertificates: customCertificatesReducer,
  studentBulkUpload: studentBulkUploadReducer,
  adminProgressTracking: adminProgressTrackingReducer,
});

export default rootReducer;